var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentBankAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.36,8.89H25v14.3H5.36Z",
    fill: "#1785c1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.24,9.72h3.34V22.19H23.24Z",
    fill: "#b1d4e8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7,22H3.7V10.16H7Z",
    fill: "#b1d4e8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.29,11.1h5.24v1.19a1,1,0,0,1-1,1H23.24a.94.94,0,0,1-.95-1Z",
    fill: "#80bbdd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.24,21.28h3.34a1,1,0,0,1,1,.95v1.19H22.29V22.23A1,1,0,0,1,23.24,21.28Z",
    fill: "#80bbdd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.84,9.72h3.34V22.19H13.84Z",
    fill: "#b1d4e8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.89,11.1h5.24v1.19a.94.94,0,0,1-.95,1H13.84a1,1,0,0,1-.95-1Z",
    fill: "#80bbdd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.84,21.28h3.34a1,1,0,0,1,.95.95v1.19H12.89V22.23A1,1,0,0,1,13.84,21.28Z",
    fill: "#80bbdd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7,13.24H3.7a1,1,0,0,1-1-1V11.1H8v1.19A1,1,0,0,1,7,13.24Z",
    fill: "#80bbdd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8,23.42H2.74V22.23a1,1,0,0,1,1-.95H7a1,1,0,0,1,1,.95Z",
    fill: "#80bbdd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.27,8.81H28.48v2a.48.48,0,0,1-.47.48H2.74a.48.48,0,0,1-.47-.48Z",
    fill: "#015382"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.74,23.19H28a.47.47,0,0,1,.47.47v2.39H2.27V23.66A.47.47,0,0,1,2.74,23.19Z",
    fill: "#015382"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.48,9.43H1.79A.48.48,0,0,1,1.31,9V6.44A.48.48,0,0,1,1.65,6L14.71,1.93a1.54,1.54,0,0,1,.85,0L28.63,6a.48.48,0,0,1,.33.45V9A.47.47,0,0,1,28.48,9.43Z",
    fill: "#1785c1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M3.22,7.52v0L15,3.84a.45.45,0,0,1,.28,0L27.05,7.5v0Z",
    fill: "#015382"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1.79,25.09H28.48a.48.48,0,0,1,.48.48v.95a.47.47,0,0,1-.48.48H1.79a.48.48,0,0,1-.48-.48v-.95A.49.49,0,0,1,1.79,25.09Z",
    fill: "#1785c1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentBankAccount);
export default __webpack_public_path__ + "static/media/payment-bank-account.f73c96414b87ad58a928536f667d362a.svg";
export { ForwardRef as ReactComponent };